import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Tiles from '../views/Tiles.vue'
import PageDetails from '../views/pageDetails.vue'
import Gallery from '../views/Gallery.vue'
import Reviews from '../views/Reviews.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/page/:mainType',
    name: 'tiles',
    component: () => import(/* webpackChunkName: "about" */ '../views/Tiles.vue')
  },
  {
    path: '/page/:mainType/:roomType',
    name: 'pages',
    component: () => import(/* webpackChunkName: "about" */ '../views/pageDetails.vue')
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: () => import(/* webpackChunkName: "about" */ '../views/Gallery.vue')
  },
  {
    path: '/reviews',
    name: 'Reviews',
    component: () => import(/* webpackChunkName: "about" */ '../views/Reviews.vue')
  },
  {
    path: '*',
    redirectTo: '/'
  }
]

const router = new VueRouter({
  routes
  // scrollBehavior (to, from, savedPosition) {
  //   return { x: 0, y: 0 }
  // }
})

export default router
